import { Patient, PatientQuery } from '@dreryk/egabinet-patient-frontend-api';
import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { Message, MessageType, StandardSpinner } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type PassportIdentityDocumentLoaderResult = {
   identityDocument: IdentityDocument | undefined;
   setPatient: (patient: Patient) => void;
};

type PassportIdentityDocumentLoaderProps = {
   readonly children: (result: PassportIdentityDocumentLoaderResult) => JSX.Element;
   readonly patientId: number;
};

export const PassportIdentityDocumentLoader = (props: PassportIdentityDocumentLoaderProps): JSX.Element | null => {
   const { data: patient, loading: patientLoading, error: patientError, setData: setPatient } = useCqrsGet<Patient>(
      () => {
         const query = new PatientQuery();
         query.id = Slot.of(props.patientId);
         return query;
      }
   );

   if (patientLoading) {
      return <StandardSpinner />;
   }

   if (patientError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      identityDocument: patient.identityDocument,
      setPatient: setPatient,
   });
};
